const BASE_URL =
  typeof window !== 'undefined'
    ? window.starlingbank.getConfig('smeBorrowingFormUrl')
    : 'https://registration.starlingbank.com/api/v1/business-lending';

export const createBusinessLendingRequest = (data) => {
  return fetch(BASE_URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });
};

export const getEligibilityStatus = (businessLendingRequestUid) => {
  return fetch(`${BASE_URL}/${businessLendingRequestUid}/eligibility-status`, {
    headers: {
      Accept: 'application/json'
    }
  });
};

export const companySearch = (searchTerm, signal) => {
  const params = new URLSearchParams({ searchTerm });
  const query = params.toString();

  return fetch(`${BASE_URL}/company-search?${query}`, {
    headers: {
      Accept: 'application/json'
    },
    signal
  });
};
